// Articles for each dataset should be added here
export const LearningHubArticlesForDatasetsMap = {
  OperatingExpenses: 'operating-expenses',
  Waste: 'waste',
  Vehicles: 'vehicles',
  EmployeeTravelExpenses: 'travel-expenses',
  Revenue: 'revenue',
  CloudCosts: 'cloud',
  CloudUsage: 'cloud',
  CloudUsageAndCost: 'cloud',
  CapitalExpenses: 'capital-expenses',
  Employees: 'employees',
  UpstreamLogistics: 'logistics',
  DownstreamLogistics: 'logistics',
  Flights: 'commercial-air-travel',
  Utilities: 'facilities-utilities',
  Buildings: 'facilities-utilities',
};
// All articles that we want to link to in the learning hub should be in this map
export const LearningHubPageSlugMap = {
  ...LearningHubArticlesForDatasetsMap,

  UnderstandingEEIOModels: 'ceda-and-useeio',
  CustomizeEmissionsFactors: 'customize-your-emissions-factors',
  CalculationCustomization: 'calculation-customization',
  CalculationMethodUpdates: 'calculation-method-updates',
  DataCollection: 'uploading-data#h-2-collecting-data',
  DataCollectionFaqs: 'uploading-data#h-2-collecting-data',
  UploadingDataValidation: 'uploading-data#h-3-validating-and-correcting-data',
  ApprovingDataForFootprintCalculation:
    'uploading-data#h-4-reviewing-and-approving-data',
  CreateFootprint: 'creating-a-footprint',
  AddingAdditionalDataWithCompanyTags: 'custom-columns',
  HowToUseApprovalWorkflows: 'data-approvals',
  Facilities: 'facilities-utilities',
  FacilitiesUtilitiesDatasets: 'facilities-utilities',
  FacilitiesGapFilling: 'facilities-utilities#h-frequently-asked-questions',
  FinanceMetricCalculations: 'metrics-watershed-finance',
  FinanceDataExplorer: 'finance-data-explorer',
  FootprintReview: 'reviewing-and-approving-footprint',
  Deduplication: 'exclusion-rules',
  Recategorization: 'recategorization-rules',
  WatershedFootprintReview: 'reviewing-and-approving-footprint',
  ApproveFootprint: 'reviewing-and-approving-footprint',
  HowToUploadData: 'uploading-data',
  ValidatingAndCorrectingDataErrors:
    'uploading-data#h-3-validating-and-correcting-data',
  ScienceBasedTargets: 'science-based-targets',
  NewDataLineage: 'data-lineage',
  Scope1Methodology: 'scope-1-direct-emissions',
  Scope2Methodology: 'scope-2-purchased-energy-emissions',
  Scope31Methodology: 'scope-3-1-purchased-goods-and-services',
  Scope32Methodology: 'scope-3-2-capital-goods',
  Scope33Methodology: 'scope-3-3-fuel-and-energy-related-activities',
  Scope34Methodology: 'scope-3-4-upstream-transportation-and-distribution',
  Scope35Methodology: 'scope-3-5-waste',
  Scope36Methodology: 'scope-3-6-business-travel',
  Scope37Methodology: 'scope-3-7-employee-commuting',
  Scope38Methodology: 'scope-3-8-upstream-leased-assets',
  Scope39Methodology: 'scope-3-9-downstream-transportation-and-distribution',
  Scope311Methodology: 'scope-3-11-sold-products',
  Scope312Methodology: 'scope-3-12-end-of-life-treatment-of-sold-products',
  Scope313Methodology: 'scope-3-13-downstream-leased-assets',
  Scope314Methodology: 'scope-3-14-franchises',
  ScienceOfTheClimateCrisis: 'science-of-the-climate-crisis',
  SelectingFuelCombustionPurpose:
    'selecting-a-purpose-for-your-buildings-fuel-combustion',
  CleanPowerPercentGuide: 'clean-power-in-facilities-and-utilities',
  GettingStartedWithMeasurement: 'getting-started-with-measurement',
  WaterMetricKinds: 'water',
  AnomalyDetection: 'anomaly-detection',
  PreparingForSecr: 'build-a-secr-report',
  CdpAutoGeneratedMetrics: 'auto-generated-metrics-cdp',
  CSRD: 'csrd',
  CreatingAndConfiguringYourCSRDReport:
    'creating-and-configuring-your-csrd-report',
  DoubleMaterialityAssessmentsUnderCSRD: 'double-materiality',
  FinancialMapping: 'financial-mapping',
  FullListBeaCodes: 'bea-codes',
  NonEmissiveSpend: 'non-emissive-spend',
  PCAFScoring: 'pcaf-scoring',
  PCAFAssetClasses: 'choosing-pcaf-asset-classes',
  FinancedEmissions: 'financed-emissions',
  ScopesOfEmissions: 'scopes-of-emissions',
  FinancedEmissionsFromEquityBondsLoans:
    'equity-corporate-bonds-business-loans',
  ClimateTargetSetting: 'setting-climate-targets',
  CompanyEstimationEngine: 'company-estimates-watershed-finance',
  CompanyEstimationEngineIndustryCodes:
    'company-estimates-watershed-finance#h-required-inputs',
  FinancedEmissionsFromRealEstate: 'commercial-real-estate',
  UploadingAnExistingFootprint: 'uploading-an-existing-footprint',
  CustomReports: 'build-a-report#h-create-custom-reports',
  ReducingSupplyChainEmissions: 'engaging-your-suppliers',
  CreateCustomMaturityScoring: 'custom-maturity-scoring',
  CreateCustomMetrics: 'custom-metrics',
  CedaWatershedFinance: 'ceda-watershed-finance',
  CustomColumnsWatershedFinance: 'custom-columns-watershed-finance',
  LegacyData: 'legacy-data',
  SupplierMapping: 'mapping-suppliers',
  HowToUploadADoubleMaterialityAssessment: 'uploading-dma',
  Benchmarks: 'benchmarks',
  UnderstandingSustainabilityDatabase: 'company-database',
  UnderstandingVerifications: 'verifications',
  MultipleFootprints: 'multiple-footprints',
  Drilldown: 'drilldown',
  OrgStructure: 'organizational-structure',
  ActivityData: 'activity-data',
  WatershedFinanceCompanyMatching: 'company-mapping-watershed-finance',
  ProductFootprints: 'watershed-product-footprints',
  PurchaseOrderJoining: 'purchase-order-joining',
  MaterialManagement: 'material-management',
  Api: 'api',
  ChangingLanguageLocale: 'locale-settings',
  aiDraftsInCaliforniaSb261: 'ai-drafts',
  ColumnsThatInfluenceOurAiModels:
    'upload-materials-data#h-helping-ai-understand-your-materials',
  ColumnsThatHelpYouConnectYourMaterialsToPurchaseOrderData:
    'purchase-order-joining#h-deciding-on-the-join-keys-to-use',
};

export const LearningHubCategorySlugMap = {
  ReportingAndRegulations: 'reporting-and-regulations',
  PolicyUpdates: 'policy-updates',
  Methodology: 'methodology',
  MethodologyUpdates: 'methodology-updates',
};

export type LearningHubPage = keyof typeof LearningHubPageSlugMap;

export type LearningHubCategory = keyof typeof LearningHubCategorySlugMap;

// If an article changes links, add it to the redirect map here so any old links still work
const LEARNING_HUB_REDIRECTS: Record<string, string> = {
  // Consolidating articles into one central data-collections-faq page
  'what-if-i-dont-have-any-data-for-this-dataset':
    'data-collection-faqs#what-if-i-dont-have-any-data-for-this-dataset-4',
  'can-i-include-multiple-data-sources-under-each-dataset-':
    'data-collection-faqs#how-do-i-add-multiple-tasks-under-each-dataset-2',
  'how-to-add-or-remove-datasets-after-setting-up-a-measurement':
    'data-collection-faqs#how-do-i-add-or-remove-datasets-5',
  'reviewing-your-footprint': 'reviewing-and-approving-footprint',
};

export const getLearningHubSlugWithRedirects = (slug: string): string =>
  LEARNING_HUB_REDIRECTS[slug] || slug;

// If you add a new place in the product that links to the learning hub, add it here for analytics
const _LEARNING_HUB_ENTRY_POINTS = [
  'LegacyActivityData',
  'Sidebar',
  'MethodologyExplainer',
  'SupplyChainCharts',
  'DatasourceInstructionsSidebar',
  'DatasourceSummaryHelpDialog',
  'DatasourceApprovalStatusDialog',
  'DataImporterHelpButton',
  'DataImporterLeaveDialog',
  'EmissionsFactorsPage',
  'EmissionsFactorsImporter',
  'MethodologyConfig',
  'SupplierPortalPage',
  'HomePage',
  'FootprintQuestionMenu',
  'RequestWatershedFootprintReview',
  'DeduplicationPage',
  'Facilities',
  'FootprintOverview',
  'UploadCompleteEmail',
  'FinanceHomepage',
  'FinanceSettings',
  'FinanceAssetSummary',
  'FinanceIndustryAutocomplete',
  'FinanceSandbox',
  'FinanceFootprintAssembly',
  'FinanceDataExplorer',
  'FinanceReporting',
  'MeasurementHomePage',
  'BuildingUtilitiesDialog',
  'CategoryRulesInfoTooltip',
  'RecategorizationIndexView',
  'CategoryRulesDetail',
  'SecrReportingComponent',
  'CdpTableView',
  'FinancialValueMappingPage',
  'FinanceProduct',
  'AnomalyDetectionCallout',
  'NewMeasurementWizard',
  'MeasurementConfiguration',
  'FootprintConfig',
  'DrilldownConfiguration',
  'FootprintCreation',
  'FootprintExports',
  'FootprintsList',
  'ImportExistingFootprint',
  'CalculationCustomization',
  'CustomTagsSetup',
  'DatasetsPage',
  'CustomReportWelcomeMessage',
  'ReportConfiguration',
  'ReportMaterialityPage',
  'SupplyChainHomePage',
  'SupplyChainMaturityScoringPage',
  'SupplierMapping',
  'MaterialityPage',
  'Benchmarks',
  'OrgStructure',
  'ActivityData',
  'SupplierResponses',
  'DataLineage',
  'MaterialUpload',
  'MaterialLibrary',
  'OrganizationSettings',
  'LocaleDialog',
  'AISandbox',
  'SupportCaseFAQ',
  'ReportPage',
  'CreateReportDialog',
  'AiReportDraftDialog',
  'PurchaseOrderJoining',
] as const;

export type LearningHubEntryPoint = (typeof _LEARNING_HUB_ENTRY_POINTS)[number];
